// 페이지 청크 로딩 중 상단에 표시하는 얇은 진행 바
import './Loader.css';

const Loader = () => (
    <div className="page-loader" role="progressbar" aria-label="loading">
        <div className="page-loader-bar" />
    </div>
);

export default Loader;
